module.exports = __webpack_public_path__ + "img/img1_11.e3e1a7d8.jpeg";